@if (data$ | async; as data) {
  <div class="mb-3 rounded-sm border border-blue-300 bg-blue-100 p-4">
    Zmiana adresu dostawy będzie miała zastosowanie od przyszłej edycji i może
    mieć wpływ na kwotę subskrypcji.
  </div>

  <app-alerts />

  <app-admin-subscription-shipping-address-form
    [data]="data"
    [subscriptionId]="id()"
    [pending]="pending()"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
